import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Picker as EmojiPicker } from 'emoji-mart';
import { getFieldPath } from 'dash-front/campaign/components/helpers';
import Popover from 'material-ui/Popover';
import IconButton from 'material-ui/IconButton';
import { TextField } from 'redux-form-material-ui';
import EmojiIcon from 'material-ui/svg-icons/editor/insert-emoticon';

import 'emoji-mart/css/emoji-mart.css';

class TextFieldWithRef extends React.PureComponent {
    render() {
        const { inputRef, emojiTextFieldStyle = {}, emojiTextFieldTextareaStyle = {}, ...rest } = this.props;

        return (
            <TextField
                {...rest}
                ref={inputRef}
                style={emojiTextFieldStyle}
                textareaStyle={emojiTextFieldTextareaStyle}
            />
        );
    }
}

TextFieldWithRef.propTypes = {
    inputRef: PropTypes.func,
    emojiTextFieldStyle: PropTypes.object,
    emojiTextFieldTextareaStyle: PropTypes.object
};

/**
 * Redux form text field with emoji
 */
class REmojiPicker extends React.PureComponent {
    state = {
        showEmojiPicker: false
    };

    static contextTypes = {
        _reduxForm: PropTypes.object
    };

    assignRef = el => {
        if (el) {
            if (el.refs.component.input instanceof Node) {
                this.input = el.refs.component.input;
            } else {
                this.input = el.refs.component.input.refs.input;
            }
        }
    };

    toggleEmoji = event => {
        event.persist();

        this.setState(({ showEmojiPicker }) => ({
            showEmojiPicker: !showEmojiPicker,
            anchorElem: event.target
        }));
    };

    close = () => this.setState({ showEmojiPicker: false });

    addEmoji = emoji => {
        const { native } = emoji;
        if (this.input) {
            const { input } = this;
            const nextSelectionStart = (input.value.slice(0, input.selectionStart) + native).length;
            const value =
                input.value.slice(0, input.selectionStart) +
                native +
                input.value.slice(input.selectionStart, input.value.length);
            const { dispatch, sectionPrefix, change } = this.context._reduxForm;
            const { name } = this.props;

            dispatch(change(getFieldPath(sectionPrefix, name), value));
            // restore the caret not to be at the end of the line
            setTimeout(() => input.setSelectionRange(nextSelectionStart, nextSelectionStart), 0);
        }
    };

    render() {
        const { name, emojiIconColor = 'currentcolor', emojiIconHoverColor = 'currentcolor', ...rest } = this.props;

        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <Field {...rest} name={name} inputRef={this.assignRef} component={TextFieldWithRef} />
                    <IconButton onTouchTap={this.toggleEmoji}>
                        <EmojiIcon color={emojiIconColor} hoverColor={emojiIconHoverColor} />
                    </IconButton>
                </div>
                <Popover
                    open={this.state.showEmojiPicker}
                    anchorEl={this.state.anchorElem}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.close}
                >
                    <EmojiPicker onClick={this.addEmoji} />
                </Popover>
            </div>
        );
    }
}

REmojiPicker.propTypes = {
    name: PropTypes.string.isRequired,
    emojiIconColor: PropTypes.string,
    emojiIconHoverColor: PropTypes.string,
    emojiTextFieldStyle: PropTypes.object,
    emojiTextFieldTextareaStyle: PropTypes.object
};

export default REmojiPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/REmojiPicker.js
 **/